import { GlideTextCell } from "./GlideTextCell.js";
class GlideCurrencyCell extends GlideTextCell {
  _formatter;
  constructor(valueGetter, formatter, emptySymbol) {
    super(valueGetter, emptySymbol);
    this._formatter = formatter;
  }
  formatValue(value) {
    if (value?.amount && (typeof value?.amount !== "number" || Number.isNaN(value.amount))) {
      throw new Error(`Invalid value: ${value.amount}`);
    }
    return value?.currency ? this._formatter(value.amount ?? 0, { format: value.currency }) : value?.amount?.toString();
  }
}
export {
  GlideCurrencyCell
};
//# sourceMappingURL=GlideCurrencyCell.js.map
